import React from "react";

const IntroductionText: React.FC = () => {
  return (
    <div className="flex-grow flex items-center justify-center self-center">
      <div>
        <h1 className="text-xl sm:text-3xl lg:text-5xl font-light text-center text-grey tracking-tight">
          Hello ! Je suis Tess,{" "}
          <span className="text-white  font-semibold">
            Product Designer UX/UI
          </span>
          , spécialisée en création d'interfaces digitales,
          <span className="text-white  font-semibold">
            {" "}
            UX research et design system.
          </span>
          .
        </h1>
      </div>
    </div>
  );
};

export default IntroductionText;
